// index.js or main file
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes, useLocation, Navigate } from 'react-router-dom';
import Login from './pages/login/login';
import AdminRedirect from './adminRedirect/admin';
import Admin from './admin/admin';
import Home from './admin/pages/home/home';
import Rules from './admin/pages/rules/rules';
import { Provider } from 'react-redux';
import { store } from './admin/store';
import LoginPage from './admin/pages/login/login';
import UserRules from './pages/rules/rules';
import SortHat from './pages/sorthat/sorthat';
import House from './pages/house/house';
import Character from './pages/character/character';
import Wand from './pages/wand/wand';
import Stage1Intro from './pages/stage1_intro/stage1_intro';
import Stage2Intro from './pages/stage2_intro/stage2_intro';
import BroomFlightGame from './pages/stage2/BroomFlightGame';
import ThankYou from './pages/thankyou/thankyou';
import Welcome from './pages/harry_potter/welcome';
import Leaderboard from './pages/leaderboard/Leaderboard';
import USER from './pages/dddUI/user';
import ThemeUpdate from './admin/pages/themeupdate/themeupdate';

function usePageBackground() {
  const location = useLocation();
  useEffect(() => {
    const body = document.body;
    const p = location.pathname;
    if (!p.startsWith("/admin") && !/^\/thankyou\/?$/i.test(p) && !/^\/leaderboard\/?$/i.test(p)) {
      body.classList.add("common-bg");
    } else {
      body.classList.remove("common-bg");
    }
  }, [location]);
}

function App() {
  usePageBackground();

  return (
    <Provider store={store}>
      <Routes>
        {/* Explicit paths (most specific first) so /admin always = theme admin, never the superadmin login */}
        <Route path="/admin/superadmin" element={<LoginPage />} />
        <Route path="/admin/rules" element={<Admin><Rules /></Admin>} />
        <Route path="/admin/themeupdate" element={<Admin><ThemeUpdate /></Admin>} />
        <Route path="/admin" element={<Admin><Home /></Admin>} />

        <Route path="*" element={
          <USER>
            <Routes>
              <Route index element={<Login />} />
              <Route path="/login" element={<Login />} />
              <Route path="/rules" element={<UserRules />} />
              <Route path="/sorthat" element={<SortHat />} />
              <Route path="/house" element={<House />} />
              <Route path="/character" element={<Character />} />
              <Route path="/wand" element={<Wand />} />
              <Route path="/stage1_intro" element={<Stage1Intro />} />
              <Route path="/stage2" element={<Stage2Intro />} />
              <Route path="/stage2/broom" element={<BroomFlightGame />} />
              <Route path="/welcome" element={<Welcome />} />
              <Route path="/harry_potter" element={<Navigate to="/welcome" replace />} />
              <Route path="/leaderboard" element={<Leaderboard />} />
              <Route path="/AdminRedirect" element={<AdminRedirect />} />
              <Route path="/thankyou" element={<ThankYou />} />
            </Routes>
          </USER>
        } />
      </Routes>
    </Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

reportWebVitals();
